import PlateGroupsProvider from '@/application/providers/PlateGroupsProvider';
import Util from  '@/application/libs/util';
import {validationFunctions as vf} from  '@/application/libs/validations';
import {validateFields, getFormatedError} from  '@/application/libs/validations';
import { t } from 'i18next';

function PlateGroupsService() {
    
    this.updatePlateRecipe = async (data, colName) => {
        const validations = {
            QTPRODUTO: {f: vf.numericalPositiveDecimal, label: t('amount')},
        };
        
        if (data.QTPRODUTO <= 0) {
            return Promise.resolve(getFormatedError(data.QTPRODUTO, validations, colName, false));
        }

        return PlateGroupsProvider.updatePlateRecipe([{
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            CDFILAUXPRAT: data.CDFILAUXPRAT,
            CDPRATO: data.CDPRATO,
            CDPRODUTO: data.CDPRODUTO,
            QTDE: data.QTPRODUTO,
            TIPORECE: data.IDTIPORECEITA
        }]);
    };

    this.getPlateGroupStandard = function(){
        return PlateGroupsProvider.getPlateGroupStandard();
    };

    this.getPlateGroupGrouping = function(){
        return PlateGroupsProvider.getPlateGroupGrouping();
    };

    this.getGrouplessPlates = function(){
        return PlateGroupsProvider.getGrouplessPlates();
    };
    
    this.getGroupsForGrouplessPlates = function(){
        return PlateGroupsProvider.getGroupsForGrouplessPlates();
    };

    this.getGroupsToAdd = function(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI
        } = Util.getFilterInSession();
        return PlateGroupsProvider.getGroupsToAdd({IDTIPORESTRICAO, CDFILIAL, CDSERVFILI});
    };

    this.getNewPlatesToAdd = function(searchText){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI, IDUTRPADCA
        } = Util.getFilterInSession();
        let filterParams = {
            CDFILIAL,
            CDSERVFILI,
            IDUTRPADCA,
            IDTIPORESTRICAO,
            CDNVPRATO: Util.getPlateNivel(),
            MAX_RESULTS: 50,
            PRATO: searchText || ''
        };
        
        return PlateGroupsProvider.getNewPlatesToAdd(filterParams);
    };
    
    this.saveNewPlate = function(data, selectedGroup){
        let params = Object.assign({
            CDPRATO:data.CDPRATO,
            CDFILAUXPRAT:data.CDFILAUXPRAT,
            NRORG:Util.getLocalVar('userData').NRORG,
            NRGRUPOPRATOSERV: selectedGroup.NRGRUPOPRATOSERV
        });

        if(params.CDPRATO){
            return PlateGroupsProvider.saveNewPlate(params);
        } else return Promise.reject('INVALID_FIELDS');
    };

    this.getGroupsetToAdd = function(){
        const { TPCONTRATO: IDTIPORESTRICAO } = Util.getFilterInSession();
        return PlateGroupsProvider.getGroupsetToAdd( {IDTIPORESTRICAO} );
    };

    this.savePlateGroupStandard = function(row, colName){
        let validations = {
            CDPADGRUPOPRATO: {f: [vf.notEmpty, vf.regex(/^\d+$/, t('the_field_must_only_contain_numbers')),
            vf.maxLength(10)], label: t('dish_group_pattern_code')},
            NMPADGRUPOPRATO: {f: vf.notEmpty, label: t('plate_group_pattern_name')},
        };
        let validationResult = validateFields(row, validations);
        if (!validationResult.error) {
            let saveData = {
                CDPADGRUPOPRATO: row.CDPADGRUPOPRATO.padStart(10, 0),
                NMPADGRUPOPRATO: row.NMPADGRUPOPRATO,
                IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO
            };
            if(row.__is_new_row){
                return PlateGroupsProvider.insertData([saveData], "PADGRUPOPRATO");
            } else {
                return PlateGroupsProvider.saveChangedData([saveData], "PADGRUPOPRATO");
            }
        } else {
            return Promise.resolve(getFormatedError(row, validations, colName, row.__is_new_row));
        }
    };

    this.savePlateGroupGrouping = function(row, colName){
        let validations = {
            CDAGRUPGRPRAT: {f: [vf.notEmpty, vf.regex(/^\d+$/, t('the_field_must_only_contain_numbers')),
            vf.maxLength(10)], label: t('dish_group_grouping_code')},
            NMAGRUPGRPRAT: {f: vf.notEmpty, label: t('dish_group_grouping_name')},
        };
        let validationResult = validateFields(row, validations);
        let _is_new = !row.NRAGRUPGRPRAT;
        if (!validationResult.error) {
            if(_is_new){
                return PlateGroupsProvider.insertData([{
                    CDAGRUPGRPRAT: row.CDAGRUPGRPRAT.padStart(10, 0),
                    NMAGRUPGRPRAT: row.NMAGRUPGRPRAT,
                    IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
                    NRORG: Util.getLocalVar('userData').NRORG
                }], "AGRUPGRPRAT");
            } else {
                return PlateGroupsProvider.saveChangedData([{
                    NRAGRUPGRPRAT: row.NRAGRUPGRPRAT,
                    NMAGRUPGRPRAT: row.NMAGRUPGRPRAT,
                }], "AGRUPGRPRAT");
            }
        } else {
            return Promise.resolve(getFormatedError(row, validations, colName, _is_new));
        }
    };

    this.saveGrouplessPlates = function(row){
        if(row.NRGRUPOPRATOSERV){
            return PlateGroupsProvider.insertData([{
                CDPRATO: row.CDPRATO,
                CDFILAUXPRAT: row.CDFILAUXPRAT,
                NRGRUPOPRATOSERV: row.NRGRUPOPRATOSERV
            }], "PRATOSEMGRUPO");
        } else {
            return Promise.resolve();
        }
    };

    this.savePlateGroups = function(data){
        let params = Object.assign({
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            IDTIPORESTRICAO: Util.getFilterInSession().TPCONTRATO,
            NRORG: Util.getLocalVar('userData').NRORG,
        }, data);

        if(params.__is_new_row){
            if(params.NMAGRUPGRPRAT_key && params.NMGRUPOPRATO_key){
                params.CDGRUPOPRATO = params.NMGRUPOPRATO_key;
                params.NRAGRUPGRPRAT = params.NMAGRUPGRPRAT_key;

                return PlateGroupsProvider.savePlateGroups(params).then(response=>{
                    return response.dataset.data[0];
                });
            } else return Promise.reject('INCOMPLETE_FIELDS');
        } else {
            return PlateGroupsProvider.updatePlateGroups(params);
        }

    };

    this.deletePlateGroupStandard = (data) => {
        let dataToDelete = data.filter(el => !el.__is_new_row);
        let returnPromise = null;
        if(data.length) {
            returnPromise = PlateGroupsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    CDPADGRUPOPRATO: de.CDPADGRUPOPRATO,
                };
            }), "PADGRUPOPRATO");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    this.deletePlateGroupGrouping = (data) => {
        let dataToDelete = data.filter(el => el.NRAGRUPGRPRAT);
        let returnPromise = null;
        if(data.length) {
            returnPromise = PlateGroupsProvider.deleteData(dataToDelete.map(de => {
                return { 
                    NRAGRUPGRPRAT: de.NRAGRUPGRPRAT,
                };
            }), "AGRUPGRPRAT");
        } else {
            returnPromise = Promise.resolve();
        }
        
        return returnPromise;
    };
    /**
     * Returns plate groups according to filtered data.
     * 
     * @returns {Promise}
     */
    this.getPlatesGroups = function(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI
        } = Util.getFilterInSession();
        return PlateGroupsProvider.getPlatesGroups({IDTIPORESTRICAO, CDFILIAL, CDSERVFILI});
    };

    /**
     * Returns plate groups according to filtered data for export.
     * 
     * @returns {Promise}
     */
    this.getExportPlatesGroup = function(){
        const {
            TPCONTRATO: IDTIPORESTRICAO,
            CDFILIAL, CDSERVFILI
        } = Util.getFilterInSession();
        return PlateGroupsProvider.getExportPlatesGroups({IDTIPORESTRICAO, CDFILIAL, CDSERVFILI});
    };
    
    /**
     * Delete selected plate groups.
     * 
     * 
     * @returns {Promise}
     */
    this.delPlateGroup = function(selectedRow){
        let params = {
            NRGRUPOPRATOSERV:selectedRow.NRGRUPOPRATOSERV
        };

        return PlateGroupsProvider.delPlateGroup(params);
    };

    /**
     * Delete selected plate.
     * 
     * 
     * @returns {Promise}
     */
    this.delPlateRegister = function(selectedRow){
        return PlateGroupsProvider.delPlateRegister({selectedRow});
    };

    /**
     * Get plates filtered by plate group and other system
     * parametrized data.
     * 
     * @param {String} groupCode
     * 
     * @returns {Promise}
     */
    this.getPlatesByGroup = function(groupCode){
        let plateFilter = {
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            NRGRUPOPRATOSERV: groupCode
        };

        return PlateGroupsProvider.getPlatesByGroup(plateFilter);
    };

    /**
     * Get plates recipe by plate row params.
     * 
     * @param {String} groupCode
     * 
     * @returns {Promise}
     */
    this.getPlateRecipe = function(plate){
        let plateFilter = {
            CDFILIAL: Util.getFilterInSession().CDFILIAL,
            CDSERVFILI: Util.getFilterInSession().CDSERVFILI,
            CDFILAUXPRAT:plate.CDFILAUXPRAT,
            CDPRATO:plate.CDPRATO,
        };

        return PlateGroupsProvider.getPlateRecipe(plateFilter);
    };
}

export default new PlateGroupsService();